import { CircularProgress } from "@mui/material";
import { Button, TextInput } from "@truevault/aquilo";
import Alert from "@mui/material/Alert";
import React from "react";
import { Field, Form } from "react-final-form";
import { Routes } from "../../root/routes";
import { requiredString, requiredEmail } from "../../util/validation";

type LoginProps = {
  onSubmit: (values: any) => void;
  loginRequest: any;
  error: boolean;
};

export const Login = ({ onSubmit, loginRequest, error }: LoginProps) => {
  return (
    <Form
      onSubmit={onSubmit}
      validate={validation}
      render={(props) => <LoginForm {...props} loginRequest={loginRequest} error={error} />}
    />
  );
};

const validation = (values) => {
  const errors = {} as any;

  requiredEmail(values, "email", errors);
  requiredString(values, "password", errors);

  return errors;
};

const LoginForm = ({ handleSubmit, loginRequest, error }) => {
  return (
    <form
      onSubmit={handleSubmit}
      style={{
        marginTop: "72px",
        width: "100%",
      }}
    >
      {error && (
        <Alert severity="error" className="mb-md">
          {error}
        </Alert>
      )}

      <div className="tw-boundary">
        <Field name="email">
          {(props) => (
            <>
              <TextInput
                autoFocus
                autoComplete="email"
                id="email"
                field="email"
                onChange={props.input.onChange}
                label="Email Address"
                labelTextColor="text-neutral-700"
                required
              />
              {props.meta.invalid && props.meta.touched && (
                <div className="text-red-800 text-[12px]">{props.meta.error}</div>
              )}
            </>
          )}
        </Field>

        <div className="mt-[12px]">
          <Field name="password">
            {(props) => (
              <>
                <TextInput
                  type="password"
                  field="password"
                  id="password"
                  onChange={props.input.onChange}
                  label="Password"
                  labelTextColor="text-neutral-700"
                  required
                />
                {props.meta.invalid && props.meta.touched && (
                  <div className="text-red-800 text-[12px]">{props.meta.error}</div>
                )}
              </>
            )}
          </Field>
        </div>

        <div className="flex justify-end">
          <a href={Routes.reset} className="text-primary-600 text-[14px] underline font-medium">
            Forgot Password?
          </a>
        </div>

        <div className="mt-[60px]">
          <Button
            onClick={handleSubmit}
            type="submit"
            color="primary"
            width="full"
            disabled={loginRequest.running}
          >
            {loginRequest.running ? <CircularProgress size={20} color="secondary" /> : "Log In"}
          </Button>
        </div>
      </div>
    </form>
  );
};
